__turbopack_context__.v({
  "checkbox": "_7Cz9QG_checkbox",
  "container": "_7Cz9QG_container",
  "icon": "_7Cz9QG_icon",
  "indicator": "_7Cz9QG_indicator",
});
